import { application } from "./application";
import LemonwayIframeController from "./lemonway_iframe_controller";
import PlacesAutocompleteController from "./places_autocomplete_controller";
import TomSelectController from "./tom_select_controller";

application.register("lemonway-iframe", LemonwayIframeController);
application.register("places-autocomplete", PlacesAutocompleteController);
application.register("tom-select", TomSelectController);
